import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import About from "@/components/About";
import Expertise from "@/components/Expertise";
import Formations from "@/components/Formations";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function LandingPage() {
    return (
        <main data-testid="landing-page" className="bg-cream text-ink">
            {/* SEO-only H1 — read by search engines, hidden visually */}
            <h1 className="sr-only">
                Atelier du Bâti Ancien — Diagnostiqueur des pathologies du bâti ancien et artisan en restauration avec matériaux biosourcés (chaux, plâtre, argile, chanvre) et peintures décoratives compatibles à Saint-Lubin-des-Joncherets (Eure-et-Loir). Accompagnement de travaux et formations personnalisées en Île-de-France, Perche et régions limitrophes.
            </h1>
            <Header />
            <Hero />
            <Services />
            <Gallery />
            <About />
            <Expertise />
            <Formations />
            <Testimonials />
            <FAQ />
            <Contact />
            <Footer />
        </main>
    );
}
